import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { I18nModule, OccProductSearchAdapter } from "@spartacus/core";
import { IconModule, ItemCounterModule, OutletModule } from "@spartacus/storefront";
import { KbAddToCartComponent } from "./kb-add-to-cart.component";

@NgModule({
 imports:[
  CommonModule,
  ReactiveFormsModule,
  I18nModule,
  IconModule,
  ItemCounterModule,
  OutletModule,
 ],
 providers: [OccProductSearchAdapter
  ],
  exports:[KbAddToCartComponent],
 declarations:[KbAddToCartComponent]
})
export class KbAddToCartModule {

}
